import { getEndpoint, ENDPOINT_GROUPS } from '../../services/service-some-api';
import { EventBus, EventTypes } from '../../consts/const-event-types';

export default class FilterComponent
{
  constructor(element)
  {
    // selectors
    this.el = element;    

    
    this.toggleButton = this.el.querySelector("[data-filter-toggle]");
    this.groupsContainer = this.el.querySelector("[data-groups]");


    // vars
    this.highlightedGroups = [];
    this.groupCheckboxes = null;
    this.checkboxDisableAllHighlighted = null;
    this.checkboxHideOffentligeChefer = null;


    // bindings
    this.loadData = this.loadData.bind(this);
    this.renderData = this.renderData.bind(this);


    this.init()
  }

  init()
  {    
    this.loadData();

    // Listener to receive any requests about what is currently selected
    EventBus.addEventListener(EventTypes.CHART_GLOBALFILTER_REQUEST, event => 
    {
      this.sendGlobalFilterEvent(event);
    })
   
  }

  async loadData()
  {
    this.data = await getEndpoint(ENDPOINT_GROUPS);

    if(this.data)
    {
      this.renderData();
    }
  }

  renderData()
  {
    const groups =  this.data.Groups.map(p => p.Group).sort();   

/*     <div class="checkbox-wrapper">
    <label class="checkbox">
      <input type="checkbox" data-uncheck-group-checkboxes />
      <span class="checklabel">Fjern fremhævede valg</span>
      <span class="checkmark"></span>
    </label>
  </div>  */

    const template = `
      <div class="filter-topbar">
        <div class="left">
          <button class="button" data-uncheck-group-checkboxes>Fjern fremhævede valg
          </button>
        </div>
        <div class="right">
          <div class="checkbox-wrapper">
            <label class="checkbox-slider right-align">
              <input type="checkbox" data-no-offentlige-chefer />
              <span class="checkmark"></span>
              <span class="checklabel">Vis ikke offentlige chefer</span>
             
            </label>
          </div>
        </div>
      </div>
      ${groups.map(m =>  this.templateCheckbox(m)).join("")}
    `;

    this.groupsContainer.innerHTML = template;


    // If JS-components are needed runtime, instantiate them manually:
    this.addEvents();;

  }

  addEvents()
  {
    this.groupCheckboxes = this.groupsContainer.querySelectorAll("[data-group-checkbox]");
    this.groupCheckboxes && this.groupCheckboxes.forEach(c => {
      c.addEventListener("click", (evt) => 
      {
        const checkbox = evt.target;
        this.updateHighlightedGroups(checkbox);


        this.checkboxDisableAllHighlighted.checked = false;
      })
    });

    // Checkbox "Fjern fremhævede valg"
    this.checkboxDisableAllHighlighted = this.groupsContainer.querySelector("[data-uncheck-group-checkboxes]");


    this.checkboxDisableAllHighlighted && this.checkboxDisableAllHighlighted.addEventListener("click", () =>
    {

      // Uncheck all group checkboxes
      this.groupCheckboxes && this.groupCheckboxes.forEach(g => { g.checked = false; });

      // Reset highlighted groups and let every chart  know 
      this.highlightedGroups = [];
      this.sendGlobalFilterEvent();
      
    })

    // Checkbox "Vis ikke offentlige chefer"
    this.checkboxHideOffentligeChefer = this.groupsContainer.querySelector("[data-no-offentlige-chefer]");
    this.checkboxHideOffentligeChefer && this.checkboxHideOffentligeChefer.addEventListener("click", () =>
    {
        this.sendGlobalFilterEvent();    
    })


    // Toggle button
    this.toggleButton && this.toggleButton.addEventListener("click", () =>
    { 
      const b = document.body;

      if(b.classList.contains("menu-open"))
      {
        b.classList.remove("menu-open");
      }
      else{
        b.classList.add("menu-open");
      }
     
    })
  }

  updateHighlightedGroups(checkbox)
  {
    const value = checkbox.value;

    var valueFound = this.highlightedGroups.find(e => e == value);
    
    if(!valueFound && checkbox.checked){
      this.highlightedGroups.push(value)
    }
    
    if(valueFound && !checkbox.checked){
      for(var i = 0; i < this.highlightedGroups.length; i++){ 
                               
          if (this.highlightedGroups[i] === value) { 
            this.highlightedGroups.splice(i, 1); 
              i--; 
          }
      }
    }

    // Set global event
    this.sendGlobalFilterEvent();
  }

  sendGlobalFilterEvent(event)
  {
    const eventData = {
      detail: { 
        dataComponent: event ? event.detail : "all",
        highlightedGroups: this.highlightedGroups,
        hidePublicLeaders: this.checkboxHideOffentligeChefer ? this.checkboxHideOffentligeChefer.checked : false
      }
    }

    const ev = new CustomEvent(EventTypes.CHART_GLOBALFILTER_UPDATE, eventData)
    EventBus.dispatchEvent(ev);
  }


  templateCheckbox(value){
    return `
    <div class="checkbox-wrapper">
      <label class="checkbox">
        <input type="checkbox" data-group-checkbox value="${value}" />
        <span class="checklabel">${value}</span>
        <span class="checkmark"></span>
      </label>
    </div>
    `;


  }
 

}
